import React from 'react';
import { ArrowForward } from 'core/icons';
import tulkojumi from 'utils/tulkojumi';
import { FlipHorizontal, StyledLink, StyledLabel } from './styled';

const PaginationButton = (props) => {
    const {
        rel,
        path,
        onClick,
        label,
        title,
        teksti
    } = props;

    let first;
    let second;
    if (rel === 'prev') {
        first = (
          <FlipHorizontal>
              <ArrowForward />
          </FlipHorizontal>
        );
        second = (
          <StyledLabel>
            {tulkojumi(teksti, 'atpakal')}
          </StyledLabel>
        );
    } else if (rel === 'next') {
        first = (
          <StyledLabel>
            {tulkojumi(teksti, 'talak')}
          </StyledLabel>
        );
        second = <ArrowForward />;
    }

    return (
        <StyledLink
            rel={rel}
            to={path || '#'}
            title={title}
            onClick={onClick}
        >
            <small>
                {label}
            </small>
            <p>
                {first}
                {second}
            </p>
        </StyledLink>
    );
};

export default PaginationButton;


// WEBPACK FOOTER //
// ./src/elements/Pagination/PaginationButton.jsx